import { createContext, useContext } from 'react';
import { ROLLOUTS } from '../../../constants';

export { ROLLOUTS };

export type Rollouts = {
    [Key in keyof typeof ROLLOUTS as (typeof ROLLOUTS)[Key]]: boolean;
};

export const defaultRolloutContext: Rollouts = {};

export const RolloutContext = createContext(defaultRolloutContext);

export const useRollout = (key: string) => {
    const context = useContext<Rollouts>(RolloutContext);

    return context[key];
};
